export const lightGray = '#9B9A9A'
export const softGray = '#F4F4F5'
export const mildGray = '#7A7A7A'
export const blue = '#157FFB'
export const mildBlue = '#BDE0FC'
export const green = '#71D327'
export const orange = '#FF6523'
export const softBlue = '#F2F9FF'

export const inputShadow = '0 1px 1px rgba(0,0,0,0.12), 0 1px 1px rgba(0,0,0,0.12)'
export const menuShadow = '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
